import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FnDynamicMenuComponent } from './fn-dynamic-menu.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { EventHandlerService } from './services/event-handler.service';
import {MatTooltipModule} from "@angular/material/tooltip";


@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    MatTooltipModule,
    TranslateModule.forChild(),
  ],
  providers: [
    EventHandlerService
  ],
  declarations: [
    FnDynamicMenuComponent,
    MenuItemComponent
  ],
  exports: [
    FnDynamicMenuComponent,
    MenuItemComponent
  ]
})

export class FnDynamicMenuModule {
}
